
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesInvites = View.LeaguesInvites.extend({
		template: JST.TippingLeaguesInvites,
		ui: {
			add_invite:      '.js-add-invite',
			send_invites:    '.js-send-invites',
			input_invite:    '.js-input-invite',
			share_btn:       '.js-share',
			gmail_btn:       '.js-gmail',
			modal_container: '#js-modal-container',
			modal:           '#js-modal',
			modal_content:   '.js-modal-content',
			select:          '.js-modal-select',
			select_all:      '.js-modal-select-all',
			modal_close:     '.js-modal-close',
			modal_submit:    '.js-modal-submit'
		}
	});

}(window, APP, Backbone, Marionette, $, _));